//preview frond page body here
import React, { useEffect, useState } from "react";
import rocket from "../../Assets/frond-details/rocket.svg";
import dollar from "../../Assets/frond-details/dollar.svg";
import calendar from "../../Assets/frond-details/calendar.svg";
import like from "../../Assets/frond-details/like.svg";
import { Image } from "@nextui-org/react";
import placholderIcon from "../../Assets/frond-details/placholder-icon.svg";
import currency from "../../Assets/frond-details/currencey.png";
import importance from "../../Assets/frond-details/importance.png";

const ShareBody = ({ frondData }) => {
  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

 


   const [frondDetails, setFrondDetails] = useState([]);
   

const formatDate = (dateString) => {
  if (!dateString) {
    return "-";
  }
  const separator = dateString.includes('-') ? '-' : '/';
  const parts = dateString.split(separator);
  
  let year, month, day;
  if (separator === '-') {
    [year, month, day] = parts;
  } else {
    [day, month, year] = parts;
  }
  const date = new Date(year, month - 1, day);

  if (isNaN(date.getTime())) {
    return "-"; 
  }
  const options = { year: 'numeric', month: 'short', day: '2-digit' };
  return new Intl.DateTimeFormat('en-GB', options).format(date).replace(' ', ', ');
};


  return (
    <>
      <section className="about-frond">
        <div className="flex flex-col items-start justify-between md:flex-row gap-x-2 gap-y-5">
          <div className="flex flex-col w-full content">
            
            {/* First row of info sections */}
            <div className="flex flex-wrap items-start sm:gap-8 lg:gap-16 info">
              
              {/* Category Section */}
              <div className="flex mb-5 gap-14">
              <div className="flex flex-col gap-2">
                <h5 className="text-cardGrayColor text-[10px] md:text-sm leading-normal font-normal">
                  Category
                </h5>
                <div className="flex items-center gap-[5px]">
                  <Image
                    src={rocket}
                    alt="Rocket"
                    className="min-w-[12px] min-h-[12px] max-w-[12px] max-h-[12px] md:min-w-[18px] md:min-h-[18px] md:max-w-[18px] md:max-h-[18px]"
                  />
                  <span className="leading-normal text-textColor text-[10px] md:text-base">
                    {frondData?.frond?.category}
                  </span>
                </div>
              </div>

              {/* Importance Section */}
              <div className="flex flex-col gap-2 min-w-[60px]">
                <h5 className="text-cardGrayColor text-[10px] md:text-sm leading-normal font-normal">
                  Importance
                </h5>
                <div className="flex items-center gap-[5px]">
                  <Image
                    src={importance}
                    alt="importance"
                    className="min-w-[12px] min-h-[12px] max-w-[12px] max-h-[12px] md:min-w-[18px] md:min-h-[18px] md:max-w-[18px] md:max-h-[18px]"
                  />
                  <span
                    className={`leading-normal text-[10px] md:text-base ${
                      frondData?.frond?.priority === "High" && "text-[#FF3D00E5]"
                    } ${
                      frondData?.frond?.priority === "Medium" && "text-[#FFC000]"
                    } ${
                      frondData?.frond?.priority === "Low" && "text-[#5CCDB0]"
                    } ${!frondData?.frond?.priority && "text-textColor"}`}
                  >
                    {frondData?.frond?.priority ? frondData?.frond?.priority : "-"}
                  </span>
                </div>
              </div>
              </div>

              {/* Budget Section */}
              <div className="flex gap-16">
              <div className="flex flex-col gap-2">
                <h5 className="text-cardGrayColor text-[10px] md:text-sm leading-normal font-normal">
                  Budget
                </h5>
                <div className="flex items-center gap-[5px]">
                  <Image
                    src={dollar}
                    alt="Dollar"
                    className="min-w-[12px] min-h-[12px] max-w-[12px] max-h-[12px] md:min-w-[18px] md:min-h-[18px] md:max-w-[18px] md:max-h-[18px]"
                  />
                  <span className="leading-normal text-textColor text-[10px] md:text-base">
                    {frondData?.frond?.budget ? frondData?.frond?.budget : "-"}
                  </span>
                </div>
              </div>

              {/* Currency Section */}
              <div className="flex flex-col gap-2">
                <h5 className="text-cardGrayColor text-[10px] md:text-sm leading-normal font-normal">
                  Currency
                </h5>
                <div className="flex items-center gap-[5px]">
                  <Image
                    src={currency}
                    alt="Currency"
                    className="min-w-[12px] min-h-[12px] max-w-[12px] max-h-[12px] md:min-w-[18px] md:min-h-[18px] md:max-w-[18px] md:max-h-[18px]"
                  />
                  <span className="leading-normal text-textColor text-[10px] md:text-base">
                    {frondData?.frond?.currency ? frondData?.frond?.currency : "-"}
                  </span>
                </div>
              </div>
            </div>
            </div>

            {/* Separate row for date sections */}
            <div className="flex flex-wrap items-start gap-6 mt-5 info">
              
              {/* Start Date Section */}
              <div className="flex flex-col gap-2">
                <h5 className="text-cardGrayColor text-[10px] md:text-sm leading-normal font-normal">
                  Start Date
                </h5>
                <div className="flex items-center gap-[5px]">
                  <Image
                    src={calendar}
                    alt="Calendar"
                    className="min-w-[12px] min-h-[12px] max-w-[12px] max-h-[12px] md:min-w-[18px] md:min-h-[18px] md:max-w-[18px] md:max-h-[18px]"
                  />
                  <span className="leading-normal text-textColor text-[10px] md:text-base">
                    {formatDate(frondData?.frond?.start_date)}
                  </span>
                </div>
              </div>

              {/* End Date Section */}
              <div className="flex flex-col gap-2">
                <h5 className="text-cardGrayColor text-[10px] md:text-sm leading-normal font-normal">
                  End Date
                </h5>
                <div className="flex items-center gap-[5px]">
                  <Image
                    src={calendar}
                    alt="Calendar"
                    className="min-w-[12px] min-h-[12px] max-w-[12px] max-h-[12px] md:min-w-[18px] md:min-h-[18px] md:max-w-[18px] md:max-h-[18px]"
                  />
                  <span className="leading-normal text-textColor text-[10px] md:text-base">
                    {formatDate(frondData?.frond?.end_date)}
                  </span>
                </div>
              </div>
            </div>

            {/* Description Section */}
            <div className="info flex items-start gap-[22px] mt-5 mb-5">
              <div className="flex flex-col gap-2">
                <h5 className="text-cardGrayColor text-[10px] md:text-sm leading-normal font-normal">
                  Description
                </h5>
                <div className={`${!frondData?.frond?.desc && "text-center"}`}>
                  <p className="leading-normal text-textColor text-[10px] md:text-base break-before-all">
                    {frondData?.frond?.desc ? frondData?.frond?.desc : "-"}
                  </p>
                </div>
              </div>
            </div>

            {/* Tags Section */}
            <div className="info flex items-start gap-[22px] mb-5">
              <div className="flex flex-col gap-2">
                <div className="flex items-center gap-[5px]">
                  <Image
                    src={like}
                    alt="Heart"
                    className="min-w-[12px] min-h-[12px] max-w-[12px] max-h-[12px] md:min-w-[18px] md:min-h-[18px] md:max-w-[18px] md:max-h-[18px]"
                  />
                  <span className="text-cardGrayColor text-[10px] md:text-sm leading-normal font-normal">
                    Tags
                  </span>
                </div>
                <div
                  className={`flex items-center text-[10px] md:text-base ${
                    frondData?.tags?.length === 0 && "justify-center"
                  } gap-2.5 flex-wrap`}
                >
                  {frondData?.tags?.length > 0
                    ? frondData?.tags.map((item, idx) => (
                        <div
                          key={idx}
                          className="py-1.5 px-2.5 rounded-[20px] bg-mainBlue text-white flex justify-center items-center"
                        >
                          <span className="text-[10px] md:text-sm leading-[16.1px]">
                            {item.name.en}
                          </span>
                        </div>
                      ))
                    : "-"}
                </div>
              </div>
            </div>
          </div>

          <div className="card-img relative w-full md:w-[300px] md:min-w-[300px] mt-5 md:mt-0">
  <div
    className={`absolute inset-0 ${
      frondData?.image ? "bg-frondDetails" : "bg-textColor"
    } z-20 rounded-[20px]`}
  ></div>
  {frondData?.image ? (
    <div
      style={{
        backgroundImage: `url(${frondData?.image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
      className="w-full h-[200px] md:w-[300px] md:h-[300px] rounded-[20px] overflow-hidden"
    />
  ) : (
    <div className="flex justify-center items-center w-full h-[200px] md:w-[300px] md:h-[300px]">
      <Image
        classNames={{ wrapper: "z-30" }}
        src={placholderIcon}
        alt={frondData?.frond?.title}
        className="w-[46px] h-[50px]"
      />
    </div>
  )}
</div>
        </div>
      </section>
    </>
  );
};

export default ShareBody;